import React from "react";
// import "./bodycomponent.css";

import ChatBot from "./chatbot/ChatBot.jsx";

function bodycomponent(props) {
  return (
   

      
  <ChatBot imageurl={props.imageurl} subMenu={props.subMenu} title={props.title} actionButtons={props.actionButtons} setfloat_Visible={props.setfloat_Visible} float_visible={props.float_visible}/>
   
    
 
  );
}

export default bodycomponent;